module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-96x96-a25b70adaa63c5aa297550c64373a526.png";